<template>
    <b-container>
      <p class="background-number" >{{selectedDay}}</p>
      <ColorPalette v-bind:colors='Object.values(colors)' :config="colorPaletteConfig"/>
      <full-calendar
        :config="config"
        :events="events"
        @day-click='dayClick'
        @event-selected="eventClick"
        @view-render='viewRender'
        @event-render='eventRender'/>
      <div class="games" v-if="releaseDates.length >= 0">
        <div v-for="(game, index) in filterGames" :key="game.id + index">
          <short-detail :game=game />
        </div>
      </div>
      <div class="d-height">
        &nbsp;
      </div>
    </b-container>
</template>

<script>
import ShortDetail from '@/views/ShortDetail.vue'
import ColorPalette from '@/components/ColorPalette.vue'
import $ from 'jquery'

export default {
  name: 'calendar',
  props: ['onIconClick'],
  components: {
    ShortDetail,
    ColorPalette
  },
  metaInfo () {
    return {
      titleTemplate: 'Video game release calendar | WhenIsGameReleased.com',
      htmlAttrs: {
        lang: 'en'
      },
      meta: [{
        vmid: 'description',
        name: 'description',
        content: 'WhenIsGameReleased, or WIGR, is your go-to web based video game release calendar for all games, both indie and AAA, both upcoming and historical, we have information on game release dates for all major platforms: PC, PS4, XBOX ONE, Nintendo Switch and many more.'
      }]
    }
  },
  data () {
    return {
      selectedDay: '',
      config: {
        customButtons: {
          customWeek: {
            text: 'week',
            click: () => this.goToWeekBoard()
          }
        },
        buttonText: {
          listWeek: 'week',
          listMonth: 'month'
        },
        firstDay: 1,
        plugins: [ 'list' ],
        defaultView: this.isMobile('default'),
        themeSystem: 'bootstrap4',
        header: {
          right: this.isMobile('month')
        },
        contentHeight: 'auto',
        selectable: true
      },
      selectedDate: null,
      colorPaletteConfig: {
        rows: 1,
        cols: 5
      },
      colors: {
        'switch': {
          title: 'Switch',
          color: '#c53d3d'
        },
        'win': {
          title: 'Windows',
          color: '#547198' // #bd7f77
        },
        'series-x': {
          title: 'Xbox Series X',
          color: '#598c55' // #598c55
        },
        'ps5': {
          title: 'PS 5',
          color: '#2e5688'
        },
        'misc': {
          title: 'Others',
          color: '#754668'
        }
      }
    }
  },
  async mounted () {
    this.currentDate()
  },
  computed: {
    games () {
      return this.$store.state.games || []
    },
    releaseDates () {
      return this.$store.state.releaseDates || []
    },
    events () {
      let arr = []

      for (let date of this.releaseDates) {
        arr.push({
          title: date.game.name,
          slug: date.game.slug,
          allDay: true,
          start: date.date,
          editable: false,
          grad: this.getColor(date)
        })
      }
      return arr
    },
    filterGames () {
      return this.releaseDates.filter(date => {
        return new Date(date.date).getTime() === this.selectedDate
      }).map(date => date.game)
    }
  },
  methods: {
    isMobile (value) {
      const Mobile = window.matchMedia('only screen and (max-width: 760px)')
      if (Mobile.matches) {
        switch (value) {
          case 'default':
            return 'listWeek'
          case 'month':
            return 'listMonth, listWeek'
        }
      } else {
        switch (value) {
          case 'default':
            return 'month'
          case 'month':
            return 'customWeek'
        }
      }
    },
    checkIsMobile () {
      const Mobile = window.matchMedia('only screen and (max-width: 760px)')
      return Mobile.matches
    },
    dayClick (date, jsEvent, view) {
      const d = new Date(date.valueOf())
      this.selectedDay = d.getDate()
      this.selectedDate = date.valueOf()
    },
    eventClick (event, jsEvent, view) {
      this.checkIsMobile() ? this.setDateToShow(event.start) : this.goToAbout(event.slug)
    },
    setDateToShow (date) {
      const d = new Date(date)
      this.selectedDay = d.getDate()
      this.selectedDate = this.dateToEpoch(d)
    },
    currentDate () {
      const val = new Date()
      this.selectedDay = val.getDate()
      this.selectedDate = this.dateToEpoch(val)
    },
    dateToEpoch (thedate) {
      var time = thedate.getTime()
      return time - (time % 86400000)
    },
    viewRender (view, element) {
      this.setButtonDisabled('prev', true)
      this.setButtonDisabled('next', true)

      this.$store.dispatch('getReleaseDatesByDates', {
        startDate: view.start,
        endDate: view.end,
        cb: () => {
          this.setButtonDisabled('prev', false)
          this.setButtonDisabled('next', false)
        }
      })
    },
    eventRender (event, el) {
      el.css('background', event.grad)
    },
    getColor (releaseDate) {
      let colors = releaseDate.platforms.map(
        plat => this.colors[plat.slug] ? this.colors[plat.slug].color : this.colors['misc'].color)

      return colors.length === 1 ? colors[0] : this.tightGradient(colors)
    },
    // Acceptable values: ( 'prev' | 'next, false | true )
    setButtonDisabled (button, state) {
      $('.fc-' + button + '-button').prop('disabled', state)
      !state ? $('.fc-' + button + '-button').removeClass('fc-state-disabled') : $('.fc-' + button + '-button').addClass('fc-state-disabled')
    },
    // TODO: Refactor
    tightGradient (colors) {
      return 'linear-gradient(to right,' + colors.reduce(
        (acc, cur, idx) => {
          if (idx === 0) {
            return cur + ', ' + cur + ' ' + ((100 / colors.length) * (idx + 1)) + '%, '
          } else if (idx === colors.length - 1) {
            return acc + cur + ' ' + ((100 / colors.length) * (idx)) + '%, ' + cur + ' 100%'
          } else {
            return acc + cur + ' ' + ((100 / colors.length) * (idx)) + '%, ' + cur + ' ' + ((100 / colors.length) * (idx + 1)) + '%, '
          }
        }, '') + ')'
    },
    getRandomColor () {
      /* var letters = '0123456789ABCDEF'
      var color = '#'
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }
      return color
      */
      const r = 55 + (Math.floor(Math.random() * 100))
      const g = 0
      const b = 80 + (Math.floor(Math.random() * 180))
      return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)
    },
    getMiscColor () {
      return '#570079'
    },
    goToAbout (slug) {
      this.$router.push({
        name: 'game-details',
        params: { slug }
      })
    },
    goToWeekBoard () {
      this.$router.push('/week')
    }
  }
}
</script>
<style>
.background-number {
  font-size: 85vmin;
  margin: 5% auto;
  left: 0;
  right: 0;
  position: fixed;
  margin-top: -30vh;
  color: #e9e9e925;
  pointer-events: none;
}

.card {
  background-color: rgba(2, 2, 2, 0.219) !important;
}

.fc-day-top {
  cursor: pointer !important;
}

.fc-event-container {
  overflow-y: scroll !important;
  max-height: 100% !important;
  cursor: pointer;
}

.fc-event {
  cursor: pointer;
  border: 1px solid #222222 !important;
}
.fc-event:hover {
    border: 1px solid #d0d0d0 !important;
}

.btn-primary {
  background-color: #222222 !important;
  border-color: #222222 !important;
  color: #CFD0D1 !important;
  border-radius: 5% !important;
}

.btn-primary:hover {
  background-color: #CFD0D1 !important;
  border-color: #CFD0D1 !important;
  color: black !important;
  cursor: pointer;
}

.fc-today {
  background-color: #2c3e50 !important;
}

.table-bordered {
  margin: 0px;
}
table {
  border-collapse: collapse;
  border: 2px solid #00000000 !important;
}

.fc-list-table {
  color:aliceblue !important;
}
.fc-list-item-time{
  display: none;
}
.fc-list-item-marker{
  display: none;
}
.fc-list-item-marker{
  display: none;
}
.fc-list-item{
  filter: opacity(1)
}

th, td {
  padding: 1em;
  background: rgba(2, 2, 2, 0.219);
  border: 2px solid #00000000 !important;
}

body {
  margin: 1.5em;
  border-color: #00000000
}
.games {
  min-height: 40vh;
}

</style>
